import { render } from "./add-faq.vue?vue&type=template&id=5f20fe3e"
import script from "./add-faq.vue?vue&type=script&lang=js"
export * from "./add-faq.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__